import { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';

import '../utils/chart-setup';
import { CHART_FONT_FAMILY, resolveCssColor } from '../utils/chart';
import type { DashboardChart } from '../types/dashboard.types';

// PRD 01 §3.2: single-series bar (환자문의), auto Y-scale (beginAtZero).
export function InquiryBarChart({ chart }: { chart: DashboardChart }) {
  const data = useMemo<ChartData<'bar', number[], string>>(
    () => ({
      labels: chart.labels,
      datasets: chart.datasets.map((ds) => ({
        label: ds.label,
        data: ds.data,
        backgroundColor: resolveCssColor(ds.color) + 'CC',
        borderColor: resolveCssColor(ds.color),
        borderWidth: 1,
        borderRadius: 4,
      })),
    }),
    [chart],
  );

  const options = useMemo<ChartOptions<'bar'>>(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: { usePointStyle: true, padding: 16, font: { size: 12, family: CHART_FONT_FAMILY } },
        },
      },
      scales: {
        x: { grid: { display: false }, ticks: { font: { size: 11 } } },
        y: { beginAtZero: true, ticks: { font: { size: 11 } } },
      },
    }),
    [],
  );

  return <Bar data={data} options={options} />;
}
